import React, { Component } from 'react';
import classes from './LottoAssistantErrorBoundary.module.scss';

class LottoAssistantErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('LottoAssistant Error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    this.props.onReset?.();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div className={classes.Container}>
          <h3 className={classes.Title}>Something went wrong</h3>
          <p className={classes.Text}>
            We encountered an unexpected error. Please try again or refresh the page.
          </p>
          <button type="button" onClick={this.handleReset} className={classes.RetryButton}>
            Try Again
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default LottoAssistantErrorBoundary;
